export class DataTransferer {
  private data = new Map();

  set<TKey, TData>(key: TKey, data: TData) {
    this.data.set(key, data);
  }

  has<TKey>(key: TKey) {
    return this.data.has(key);
  }

  get<TKey, TData>(key: TKey) {
    const data = this.data.get(key) as TData;
    this.data.delete(key);
    return data;
  }
}
